import { render, staticRenderFns } from "./addVip.vue?vue&type=template&id=92f21ac4&lang=pug"
import script from "./addVip.vue?vue&type=script&lang=js"
export * from "./addVip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports